<nav class="navbar" role="navigation" aria-label="Barra principal">

  <!-- ── Marca ─────────────────────────────────────────────────────────── -->
  <div class="navbar__brand">
    <button
      class="navbar__toggle"
      type="button"
      (click)="toggleSidebar()"
      [attr.aria-label]="(isSidebarOpen ? 'NAVBAR.CLOSE_PANEL' : 'NAVBAR.OPEN_PANEL') | transloco">
      @if (isSidebarOpen) {
        <img src="public/icons/actions/close-panel-icon.svg" alt="" class="navbar__icon" />
      } @else {
        <img src="public/icons/actions/open-panel-icon.svg" alt="" class="navbar__icon" />
      }
    </button>

    <button
      class="navbar__logo"
      type="button"
      (click)="goToHome()"
      [attr.aria-label]="'NAVBAR.GO_HOME' | transloco">
      <span class="navbar__logo-mark">
        <img
          src="/public/images/logos/logo-logit.svg"
          alt=""
          class="navbar__logo-mark-image"
        />
      </span>
      <span class="navbar__logo-text">
        LRP <span class="navbar__logo-sub">{{ 'NAVBAR.BRAND_SUB' | transloco }}</span>
      </span>
    </button>
  </div>

  <!-- ── Búsqueda ──────────────────────────────────────────────────────── -->
  <div class="navbar__center">
    <app-global-search />
  </div>

  <!-- ── Acciones ──────────────────────────────────────────────────────── -->
  <div class="navbar__actions">

    @if (userName) {
      @if (isCompaniesLoading()) {
        <div class="navbar__skeleton"></div>
      } @else {
        <p-select
          [options]="companies()"
          optionLabel="razonSocial"
          optionValue="proveedorExternoID"
          [(ngModel)]="selectedProveedorExternoId"
          [showClear]="false"
          (onChange)="onCompanyChange($event.value)"
          [disabled]="companies().length === 0"
          styleClass="navbar__company-select"
          panelStyleClass="navbar-company-panel"
          appendTo="body"
          [placeholder]="'NAVBAR.COMPANY' | transloco"
          [emptyMessage]="'NAVBAR.NO_RESULTS' | transloco"
        />
      }
    }

    <button
      type="button"
      class="navbar__user-trigger"
      (click)="userPanel.toggle($event)"
      [pTooltip]="'NAVBAR.MY_ACCOUNT' | transloco"
      tooltipPosition="bottom"
    >
      <span class="navbar__user-name">{{ getInitials() }}</span>
      <span class="navbar__user-info">
        <span class="navbar__user-fullname">{{ getFullName() }}</span>
        @if (getCompanyName()) {
          <span class="navbar__user-company">{{ getCompanyName() }}</span>
        }
      </span>
      <span class="material-symbols-outlined navbar__user-chevron" aria-hidden="true">keyboard_arrow_down</span>
    </button>
    <p-popover
      #userPanel
      styleClass="user-menu-panel"
      (onHide)="userMenu.closeLanguageMenu()"
    >
      <app-user-menu #userMenu (closeEvent)="userPanel.hide()" />
    </p-popover>
  </div>

</nav>
